import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'fori'
})
export class ForIPipe implements PipeTransform {
    transform(length: number): any[] {
        return new Array(length);
    }
}
